(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.bz-reveal:not(.bz-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bz-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bz-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initHero() {
    document.querySelectorAll('.bz-hero').forEach(function (h) {
      requestAnimationFrame(function () { h.classList.add('bz-loaded'); });
    });
  }

  function initStars() {
    document.querySelectorAll('.bz-stars[data-count]').forEach(function (box) {
      if (box.childElementCount) return;
      var n = parseInt(box.getAttribute('data-count'), 10) || 0;
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.style.left = Math.random() * 100 + '%';
        s.style.top = Math.random() * 100 + '%';
        s.style.animationDelay = (Math.random() * 4).toFixed(2) + 's';
        var size = Math.random() < 0.15 ? 3 : 2;
        s.style.width = s.style.height = size + 'px';
        box.appendChild(s);
      }
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-bz-count]');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseFloat(el.getAttribute('data-bz-count'));
        var decimals = (el.getAttribute('data-bz-count').split('.')[1] || '').length;
        var prefix = el.getAttribute('data-prefix') || '';
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null, dur = 1600;
        function step(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGallery() {
    document.querySelectorAll('[data-bz-gallery]').forEach(function (g) {
      var main = g.querySelector('.bz-gallery__main img');
      g.querySelectorAll('.bz-gallery__thumbs button').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('.bz-gallery__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = b.getAttribute('data-src');
            main.srcset = b.getAttribute('data-srcset') || '';
            main.alt = b.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 180);
        });
      });
    });
  }

  function initQty() {
    document.querySelectorAll('.bz-qty').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-step') === '+' ? 1 : -1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-bz-product]').forEach(function (root) {
      var json = root.querySelector('script[data-bz-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var price = root.querySelector('[data-bz-price]');
      var compare = root.querySelector('[data-bz-compare]');
      var btn = root.querySelector('[data-bz-add]');
      var money = root.getAttribute('data-money-format') || '${{amount}}';
      function fmt(cents) {
        var n = (cents / 100).toFixed(2);
        return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
      }
      root.querySelectorAll('.bz-option input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var chosen = [];
          root.querySelectorAll('.bz-option').forEach(function (opt) {
            var c = opt.querySelector('input:checked');
            chosen.push(c ? c.value : null);
          });
          var v = variants.find(function (x) {
            return x.options.every(function (o, i) { return o === chosen[i]; });
          });
          if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
          idInput.value = v.id;
          if (price) price.textContent = fmt(v.price);
          if (compare) {
            compare.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : '';
          }
          btn.disabled = !v.available;
          btn.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
        });
      });
    });
  }

  function initStickyAtc() {
    var bar = document.querySelector('.bz-sticky-atc');
    var anchor = document.querySelector('[data-bz-add]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    });
    io.observe(anchor);
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () { anchor.click(); });
  }

  function initAll() {
    initHero(); initStars(); initReveal(); initCountUp(); initGallery(); initQty(); initVariants(); initStickyAtc();
  }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
